import React from 'react';
import { StarIcon, QuoteIcon, ArrowRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'María',
  location: 'Ciudad de México',
  age: '34 años',
  before: 'Pedía pizza 4 veces por semana por cansancio',
  after: 'Ahora la cena está lista antes de que me cambie de ropa',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=faces'
}, {
  name: 'Sofía',
  location: 'Buenos Aires',
  age: '29 años',
  before: 'Tiraba comida cada semana y gastaba de más',
  after: 'Con el planificador ahorro $200 al mes en el súper',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=faces'
}, {
  name: 'Valentina',
  location: 'Bogotá',
  age: '41 años',
  before: '3 hijos, cero tiempo, mucha culpa',
  after: 'Opciones rápidas me quitaron un peso de encima',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop&crop=faces'
}, {
  name: 'Carolina',
  location: 'Santiago',
  age: '38 años',
  before: 'Buscaba recetas en Google 30 min cada noche',
  after: 'Abro el PDF y en 5 minutos está todo resuelto',
  rating: 5,
  image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=400&h=400&fit=crop&crop=faces'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-orange-50" data-id="element-321">
      <div className="container mx-auto px-4" data-id="element-322">
        <div className="text-center mb-16" data-id="element-323">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4" data-id="element-324">
            Lo que dicen otras mujeres ocupadas
          </h2>
          <p className="text-gray-600" data-id="element-325">
            Mujeres reales que recuperaron su tiempo y su paz mental
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-326">
          {testimonials.map((t, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-orange-100 flex flex-col h-full" data-id="element-327">
              <div className="flex items-center gap-3 mb-6" data-id="element-328">
                <img src={t.image} alt={t.name} className="w-12 h-12 rounded-full object-cover border-2 border-rose-200" data-id="element-329" />
                <div className="flex-1" data-id="element-330">
                  <p className="font-bold text-gray-900" data-id="element-331">{t.name}</p>
                  <div className="flex text-yellow-400" data-id="element-332">
                    {[...Array(t.rating)].map((_, i) => <StarIcon key={i} className="w-3 h-3 fill-current" data-id="element-333" />)}
                  </div>
                </div>
              </div>

              <div className="mb-4 flex-grow space-y-4" data-id="element-334">
                <div className="bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-335">
                  <p className="text-xs font-bold text-red-400 uppercase mb-1" data-id="element-336">
                    Antes
                  </p>
                  <p className="text-gray-600 text-sm italic" data-id="element-337">"{t.before}"</p>
                </div>

                <div className="flex justify-center" data-id="element-338">
                  <ArrowRightIcon className="w-5 h-5 text-gray-300 transform rotate-90 md:rotate-90" data-id="element-339" />
                </div>

                <div className="bg-green-50 p-3 rounded-lg border border-green-100" data-id="element-340">
                  <p className="text-xs font-bold text-green-500 uppercase mb-1" data-id="element-341">
                    Ahora
                  </p>
                  <p className="text-gray-800 text-sm font-medium" data-id="element-342">
                    "{t.after}"
                  </p>
                </div>
              </div>

              <div className="border-t border-gray-100 pt-4 mt-auto" data-id="element-343">
                <p className="text-xs text-gray-500" data-id="element-344">
                  {t.location}, {t.age}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}